module.exports = __webpack_public_path__ + "static/media/serviots.1894e76f.jpg";